<template lang="pug">
  //- Тот же значок, что у напоминаний и дедлайнов (NotificationTaskReminder,
  //- NotificationTaskExpires): день рождения — такое же напоминание
  Icon.icon(name="notification-lightning" v-if="type === 'icon'")
  div(v-else-if="type === 'title'")
    | Сегодня день рождения у клиента {{ item.info.clientName }}
    //- Контакты рядом с текстом: по этому уведомлению клиента как раз и
    //- поздравляют, поэтому телефон с почтой сразу готовы к звонку и письму.
    //- Оба поля у клиента необязательные — пустые не показываем
    .contacts(v-if="phone || email")
      a(v-if="phone" :href="`tel:${phone}`") {{ phone }}
      a(v-if="email" :href="`mailto:${email}`") {{ email }}
</template>

<script>
export default {
  name: 'NotificationCrmClientBirthday',
  props: {
    item: Object,
    type: String,
  },
  computed: {
    phone() { return this.item.info.clientPhone || ''; },
    email() { return this.item.info.clientEmail || ''; },
  },
};
</script>

<style scoped lang="scss">
.contacts {
  display: flex;
  flex-wrap: wrap;
  gap: 4px 16px;
  margin-top: 4px;
  font-size: 12px;
  flex-direction: column;
}
</style>
